import React, {
    PureComponent
} from 'react';
import Paging from 'components/Paging'
import {
    Select, Table, Button, Pagination, MessageBox,Input
} from 'element-react';
import style from './index.scss';
import './educationTrainingOrganization.css'

import star from 'images/edu/star.png';
import mes1 from 'images/edu/mes1.png';
import mes2 from 'images/edu/mes2.png';
import mes3 from 'images/edu/mes3.png';
import mes4 from 'images/edu/mes4.png';
import mes5 from 'images/edu/mes5.png';
import mes6 from 'images/edu/mes6.png';
import mes7 from 'images/edu/mes7.png';
import {
    Link
} from 'react-router-dom';

export default class EducationTrainingOrganization extends PureComponent {

    state = {
        area: [
            {tabName:"全部",id:0},
            {tabName:"生活 | 服务业",id:1},
            {tabName:"人力 | 行政",id:2},
            {tabName:"销售 | 采购",id:3},
            {tabName:"销售 | 采购",id:4},
            {tabName:"市场 | 媒介|广告|设计",id:5},
            {tabName:"市场 | 媒介|广告|设计",id:6},
        ],
        city: [
            {tabName:"全部",id:0},
            {tabName:"海南",id:1},
            {tabName:"三亚市",id:2},
            {tabName:"海口市",id:3},
            {tabName:"三沙市",id:4},
            {tabName:"儋州市",id:5},
            {tabName:"文昌市",id:6},
            {tabName:"琼海市",id:7},
            {tabName:"万宁市",id:8},
            {tabName:"文昌市",id:9},
        ],
        sort: [
            {tabName:"最新发布",id:0},
            {tabName:"服务次数",id:1},
            {tabName:"好评率",id:2},
        ],
        ulOnetype:true,
        ulTwotype:true,
        currentIndex:0,
        currentIndex2:0,
        currentIndex3:0,
        display:'none',
        displayTwo:'none',
        value: '',
        areaValue: ''
    };

    toApplicationProcess = (type) => {
        this.setState({
            index: type
        })

    }
    tabChoiced=(id)=>{
        // tab切换的方法
        this.setState({
            currentIndex:id
        });
    }
    tabChoiced2=(id)=>{
        // tab切换的方法
        this.setState({
            currentIndex2:id
        });
    }
    tabChoiced3=(id)=>{
        // tab切换的方法
        this.setState({
            currentIndex3:id
        });
    }
    ulOne = (type)=>{
        if (type == 1){
            this.setState({
                ulOnetype:!this.state.ulOnetype,
                display: this.state.ulOnetype ? 'none': 'block'
            });
        } else {
            this.setState({
                ulTwotype:!this.state.ulTwotype,
                displayTwo: this.state.ulTwotype ? 'none': 'block'
            });
        }


    }
    toApplicationGuide = (index) => {
        this.props.history.push('/preferential/applicationGuide')
    }
    renderList(list){
        var arr = [];
        for(var i =0 ;i<list.length;i++){
            if (i <6){
                var temp=  <li className={`${this.state.index === i?'active':null}`} key={i} onClick={() => this.toApplicationProcess(i)}>
                    {list[i]}
                </li>
                arr.push(temp);
            }
        }
        return arr;
    }

    render() {

        const {
            city, area, value, areaValue,display,displayTwo,sort
        } = this.state;

        var _this=this;
        var tabList= this.state.area.map(function(res,index) {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            var tabStyle=res.id==this.state.currentIndex ? 'active' : '';
            if (index < 6){
                return    <li key={index} onClick={this.tabChoiced.bind(_this,res.id)} className={tabStyle}>{res.tabName}</li>
            }
        }.bind(_this));
        var tabList2= this.state.area.map(function(res,index) {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            var tabStyle=res.id==this.state.currentIndex ? 'active' : '';
            if (index > 5){
                return    <li key={index} onClick={this.tabChoiced.bind(_this,res.id)} className={tabStyle}>{res.tabName}</li>
            }
        }.bind(_this));
        var tabList3= this.state.city.map(function(res,index) {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            var tabStyle=res.id==this.state.currentIndex2 ? 'active' : '';
            if (index < 9){
                return    <li key={index} onClick={this.tabChoiced2.bind(_this,res.id)} className={tabStyle}>{res.tabName}</li>
            }
        }.bind(_this));
        var tabList4= this.state.city.map(function(res,index) {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            var tabStyle=res.id==this.state.currentIndex2 ? 'active' : '';
            if (index > 8){
                return    <li key={index} onClick={this.tabChoiced2.bind(_this,res.id)} className={tabStyle}>{res.tabName}</li>
            }
        }.bind(_this));
        var tabList5= this.state.sort.map(function(res,index) {
            // 遍历标签页，如果标签的id等于tabid，那么该标签就加多一个active的className
            var tabStyle=res.id==this.state.currentIndex3 ? 'active' : '';
            return    <li key={index} onClick={this.tabChoiced3.bind(_this,res.id)} className={tabStyle}>{res.tabName}</li>
        }.bind(_this));
        return (
            <div className="edu_organ" >
                <div className="ft edu_organleft">
                    <div className="tab_top">
                        <ul className="tabs">
                            {/*<li style={{display: display}}>分类</li>*/}
                            <li>分类</li>
                            {tabList}
                            <li onClick={_this.ulOne.bind(_this,1)}>更多></li>
                        </ul>
                        <ul className="tabNone" style={{display: display}}>
                            {tabList2}
                        </ul>
                        <ul className="tabs tabsTwo">
                            {/*<li style={{display: display}}>分类</li>*/}
                            <li>地区</li>
                            {tabList3}
                            <li onClick={_this.ulOne.bind(_this,2)}>更多></li>
                        </ul>
                        <ul className="tabNone" style={{display: displayTwo}}>
                            {tabList4}
                        </ul>

                    </div>
                    <ul className="tab_green">
                        <li>排序</li>
                        {tabList5}
                    </ul>
                    <div className="edu_input">
                        <Input placeholder="请输入内容" append={<Button type="primary" icon="search"></Button>} />
                    </div>
                    <div className="listname">机构列表</div>
                    <div style={{clear:'both'}}></div>
                    <div className="edu_content">
                        <ul>
                            <Link to="/educationTraining/eduOrganizationDetail">
                                <li>
                                    <div className="ft img">
                                        <img src={mes1} />
                                    </div>
                                    <div className="ft titles">
                                        <div>青鸟军人培训中心</div>
                                        <div>培训课程：计算机、创新学、交际学...</div>
                                        <div>培训次数：15</div>
                                    </div>
                                    <div className="ft third">
                                        <div>好评率：
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                        </div>
                                        <div>地   址：海南海口市龙华区30号培训大厦8楼</div>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/educationTraining/eduOrganizationDetail">
                                <li>
                                    <div className="ft img">
                                        <img src={mes2} />
                                    </div>
                                    <div className="ft titles">
                                        <div>海口成功培训中心</div>
                                        <div>培训课程：计算机、创新学、交际学...</div>
                                        <div>培训次数：15</div>
                                    </div>
                                    <div className="ft third">
                                        <div>好评率：
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                        </div>
                                        <div>地   址：海南海口市龙华区30号培训大厦8楼</div>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/educationTraining/eduOrganizationDetail">
                                <li>
                                    <div className="ft img">
                                        <img src={mes3} />
                                    </div>
                                    <div className="ft titles">
                                        <div>非凡培训中心</div>
                                        <div>培训课程：计算机、创新学、交际学...</div>
                                        <div>培训次数：15</div>
                                    </div>
                                    <div className="ft third">
                                        <div>好评率：
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                        </div>
                                        <div>地   址：海南海口市龙华区30号培训大厦8楼</div>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/educationTraining/eduOrganizationDetail">
                                <li>
                                    <div className="ft img">
                                        <img src={mes4} />
                                    </div>
                                    <div className="ft titles">
                                        <div>南国就业辅导中心</div>
                                        <div>培训课程：计算机、创新学、交际学...</div>
                                        <div>培训次数：15</div>
                                    </div>
                                    <div className="ft third">
                                        <div>好评率：
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                        </div>
                                        <div>地   址：海南海口市龙华区30号培训大厦8楼</div>
                                    </div>
                                </li>
                            </Link>
                            <Link to="/educationTraining/eduOrganizationDetail">
                                <li>
                                    <div className="ft img">
                                        <img src={mes5} />
                                    </div>
                                    <div className="ft titles">
                                        <div>硅谷学院</div>
                                        <div>培训课程：计算机、创新学、交际学...</div>
                                        <div>培训次数：15</div>
                                    </div>
                                    <div className="ft third">
                                        <div>好评率：
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                            <img src={star} />
                                        </div>
                                        <div>地   址：海南海口市龙华区30号培训大厦8楼</div>
                                    </div>
                                </li>
                            </Link>
                        </ul>
                    </div>
                    <Paging />
                </div>
                <div className="ft edu_organRight">
                    <div className="titles">
                        推荐培训机构
                    </div>
                    <ul>
                        <li>
                            <img src={mes6} />
                            <div className="titless">
                                汽车服务
                            </div>
                            <div className="seson">项目分类：汽配、汽车城、二手车交易...</div>
                            <div className="seson">培训次数：15</div>
                            <div className="seson">好评率： <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} /></div>
                        </li>
                        <li>
                            <img src={mes7} />
                            <div className="titless">
                                医疗器械
                            </div>
                            <div className="seson">项目分类：医疗器械，代理销售、服务...</div>
                            <div className="seson">培训次数：15</div>
                            <div className="seson">好评率： <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} /></div>
                        </li>
                        <li>
                            <img src={mes6} />
                            <div className="titless">
                                互联网、软件服务
                            </div>
                            <div className="seson">项目分类：互联网、IT软件服务...</div>
                            <div className="seson">培训次数：15</div>
                            <div className="seson">好评率： <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} />
                                <img src={star} /></div>
                        </li>
                    </ul>
                </div>
                <div style={{clear:'both'}}></div>
            </div>

        )
    }
}
